import React from 'react';
import { Row, Col } from 'antd';
// import Login from './login'
import cookie from 'react-cookies';

import { Link } from "react-router-dom";



class Tabbar extends React.Component {
    constructor(props) {
        //父组件传入参数
        super(props);    
        //当前组件状态
        this.state = {    
            // showLogin:false,
            loggedIn:false,
			topBar:true,
            username:'',
        }
    };
    
    componentDidMount(){
        this.checkLogin();
		window.addEventListener("scroll",this.scrollTabbar)
        
        if(this.getUrlparameter("navtologin") === "true"){this.setState({showLogin:true,})}
    }

    getUrlparameter =(e) =>{
        let loc = window.location.href;
        let parameters = decodeURI(loc.substr(loc.indexOf("?")+1, loc.length-loc.indexOf("?"))).split("&");
        let paValues = {}
        for (let i = 0; i < parameters.length; i++) {
            let key = parameters[i].substr(0,parameters[i].indexOf("="))
            let value = parameters[i].substr(parameters[i].indexOf("=")+1, parameters[i].length-parameters[i].indexOf("="));
            paValues[key] = value;
        }
        return paValues[e];
    }


    checkLogin = () =>{
        // console.log(cookie.load("jwt_v2"))
        if(cookie.load("jwt_v2") === undefined){
            this.setState({
                loggedIn:false,
            })
        }else{
            this.setState({
                loggedIn:true,
                username:cookie.load("phoneNumber_v2")
            })
        }
    }
	
	scrollTabbar = e =>{
		if(document.documentElement.scrollTop === 0){
			this.setState({topBar:true})
		}else{
			if(this.state.topBar===true){this.setState({topBar:false})}
		}
	}

    // showLoginPopup=()=>{
    //     this.setState({showLogin:true,})
    // }

    // closeShowLogin = () =>{
    //     this.setState({showLogin:false})
    //     this.checkLogin();
    // }

    loginout = () =>{
        cookie.remove('jwt_v2' ,{ path:"/",domain:".moxidata.cn" });
		cookie.remove('UserUid_v2' ,{ path:"/",domain:".moxidata.cn"});
		cookie.remove('modelid_v2' ,{ path:"/",domain:".moxidata.cn"});
		cookie.remove('phoneNumber_v2' ,{ path:"/",domain:".moxidata.cn"});

        cookie.remove('jwt_v2' ,{ path:"/" });
        cookie.remove('UserUid_v2' ,{ path:"/"});
        cookie.remove('modelid_v2' ,{ path:"/"});
        cookie.remove('phoneNumber_v2' ,{ path:"/"});
        
        window.location.reload() 
    }

    navtouserbs = () =>{
        // console.log("navto")
        window.location.href="https://app.moxidata.cn/userbackstage/"
    }

    render(){
        return(
            <>  
                {/*{
                    this.state.showLogin && <Login closeLogin={this.closeShowLogin} />
                }*/}
                <Row className='tabbar-body_v2' justify='space-between'>
                    <Row className='tabbar-body-left'>
                        <Link to="/forest/" className='tabbar-item tabbar-item-left'>首页</Link>
                        <Link to="/forest/" className='tabbar-item tabbar-item-left'>文旅森林</Link>
                        <a href="https://app.moxidata.cn/moximerchants/moxiindex/" className='tabbar-item tabbar-item-left'>魔席招商</a>
                        <a href='https://app.moxidata.cn/college/' className='tabbar-item tabbar-item-left'>文旅学院</a>
                    </Row>
                    <Row  className='tabbar-body-mid' justify='center'>
                        <Col className='tabbar-logo-body'>
                            <img src="/forest/image/moxi2.png" className='tabbar-logo-img' alt=""/>
                            <div className='tabbar-logo-text'>魔席</div>
                        </Col>
                    </Row>

                    {
                        !this.state.loggedIn && 
                        <Row  className='tabbar-body-right' justify='end'>
                            <Link className='tabbar-item tabbar-item-right' to="/forest/login">登录</Link>
                            <Link className='tabbar-item tabbar-item-right' to="/forest/login">注册</Link>
                        </Row>
                    }
                    {
                        this.state.loggedIn && 
                        <Row  className='tabbar-body-right' justify='end'>
                            <a href='https://app.moxidata.cn/userbackstage/' className='tabbar-item tabbar-item-right'>{this.state.username}</a>
                            {/*<Link className="tabbar-item tabbar-item-right"  to="/forest/userbs">{this.state.username}</Link>*/}
                            <Col className="tabbar-item tabbar-item-right" onClick={this.loginout}>退出登录</Col>
                        </Row>
                    }

                
                </Row>
            </>
        );

    }
        
}

export default Tabbar;